<div class="surface-card p-4 shadow-2 border-round">
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
     <div class="flex justify-start md:justify-start">
        <span class="p-input-icon-left mr-4">
            <i class="pi pi-search"></i>
            <input type="text" pInputText placeholder="Cerca"
              (input)="filtraUtenti($event)" [disabled]="isLoadingResults" />
          </span>
       
      </div>
      <div class="flex justify-end md:justify-center">
        <span *ngIf="!filterIsSet" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">UTENTI</span>
        <span *ngIf="filterIsSet && filtroAzienda" class="text-xl font-medium text-2000 align-items-center mr-4" style="color: #6c092c">UTENTI DELL'AZIENDA:<span style="font-weight: bold;"> {{aziendaFiltro?(aziendaFiltro.ragioneSociale | uppercase):''}}</span> </span>

      </div>
      
     <div class="flex justify-end md:justify-end">
      <button *ngIf="filterIsSet" pButton pRipple type="button" icon="pi pi-filter-slash"
        class="py-2 px-3 md:mb-0 mr-0 md:mr-3 p-button-rounded p-button-outlined" style="background-color: rgb(73, 162, 173); color: white;"
        (click)="reloadDataRemovingFilter()" [disabled]="isLoadingResults"
        pTooltip="Rimuovi filtro">
      </button>
       <button pButton pRipple type="button" icon="pi pi-refresh" class="p-button-rounded mr-2 p-button-outlined" style="background-color: rgb(175, 209, 175); color: white;" (click)="loadUtenti()"></button>
       <button 
          pButton type="button" icon="pi pi-user-plus"
          pTooltip="Nuovo Utente"
          class="inline-flex justify-content-center align-items-center mb-1 mr-1"
          style="background-color:#CBEFFF ; color: #007bff; border-color: #CBEFFF; font-family:'Poppins'"
          tooltipPosition="top"
          label="Nuovo"
          (click)="openCreaUtenteDialog()" 
          [disabled]="isLoadingResults">
       </button>
       
     </div>
 </div>
            <div fxFlex="95%" class="mt-2">
                <p-table #utentiDT styleClass="p-datatable-sm" [value]="utenti" dataKey="id" [(selection)]="selectedUtente"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="10" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10,25,50]" responsiveLayout="scroll" [paginator]="true"
                currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                [globalFilterFields]="['nome','mail','ruolo.codice','azienda.ragioneSociale']"
                [loading]="isLoadingResults"
                [sortField]="'nome'" [sortOrder]="1">

                <ng-template pTemplate="header">
                    <tr>

                        <th pSortableColumn="nome">
                            <div class="flex justify-content-between align-items-center">
                              Nome
                              <p-sortIcon field="nome"></p-sortIcon>
                            </div>
                          </th>
                          <th pSortableColumn="mail">
                            <div class="flex justify-content-between align-items-center">
                              Mail
                              <p-sortIcon field="mail"></p-sortIcon>
                            </div>
                          </th>

                          <th pSortableColumn="ruolo.codice" class="text-center">
                              Ruolo
                              <p-sortIcon field="ruolo.codice"></p-sortIcon>
                          </th>
                          <th pSortableColumn="azienda.ragioneSociale" class="text-center">
                            Azienda
                            <p-sortIcon field="azienda.ragioneSociale"></p-sortIcon>
                        </th>
                   <th class="text-center" >Azioni</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td> <span class="text-uppercase" style="font-weight: 500; font-weight: bold;">{{row.nome | uppercase}}</span> </td>
                        <td> <span class="text-lowercase">{{row.mail}}</span> </td>
                        <td class="text-center"> <span class="text-lowercase" [ngClass]="getRuoloClass(row.ruolo.codice)">{{row.ruolo?row.ruolo.codice:''}}</span> </td>
                        <td class="text-center"> 
                          <p-tag
                              [value]="row.azienda.ragioneSociale | uppercase"
                              [style]="{
                                'background-color': row.azienda.colore ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '13px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"

                            class="mr-1"
                        ></p-tag>
<!--                           <span class="text-uppercase" [ngClass]="row.azienda?getAziendaClass(row.azienda):''" style="font-weight: bold; font-size: 12px;" >{{row.azienda?(row.azienda.ragioneSociale | uppercase):''}}</span> 
 -->                        </td>

                       <td class="flex justify-content-center align-items-center" >
                        <button pButton type="button" style="color:rgb(44, 113, 144);" icon="pi pi-user-edit" class="p-button-rounded p-button-text" tooltipPosition="top" pTooltip="Modifica Utente"
                            (click)="openModificaUtenteDialog(row)"
                            [disabled]="row.ruolo.codice==='SUPERADMIN'"
                            >
                        </button>
                        <button pButton pRipple type="button" icon="pi pi-trash"
                            class="p-button-rounded p-button-text"
                            (click)="openDeleteUtente(row)"
                            style="color:red;" tooltipPosition="top" pTooltip="Elimina Utente"
                            [disabled]="row.ruolo.codice==='SUPERADMIN'"
                            >
                        </button>
                        </td>
                      </tr>
                </ng-template>
              </p-table>
            </div>
		</div>

<p-dialog [(visible)]="showDeleteConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
    <div class="flex flex-column align-items-center my-4">
        <span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
            <i class="pi pi-trash text-5xl"></i>
        </span>
        <div class="font-medium text-2xl text-900">ELIMINAZIONE</div>
    </div>
    <p class="line-height-3 p-0 m-0">
       Confermi di voler eliminare l'utente <span style="font-weight: bold;">{{selectedUtente?selectedUtente.nome.toUpperCase():''}}</span>?
    </p>
    <ng-template pTemplate="footer">
        <div class=" border-top-1 surface-border pt-3 flex">
            <button pButton pRipple icon="pi pi-times" styleClass="p-button-success" (click)="showDeleteConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2"></button>
            <button pButton pRipple icon="pi pi-check" styleClass="p-button-warning" (click)="confermaEliminazioneUtente()" label="CONFERMA" class="w-6 ml-2"></button>
        </div>
    </ng-template>
</p-dialog>


<p-toast position="top-center"></p-toast>
